export enum SAN_HEADER {
  CLOSE = "search_close",
  OPEN = "search_open",
  X = "search_x",
  CANCEL = "search_cancel",
}

export enum TRACKING_EVENT {
  SUBMIT = "tracking.bct.submitEvent",
  ON_NEXT_PI = "tracking.bct.trackOnNextPageImpression",
}

export enum SanSearchHistory {
  EXISTS = "exists",
  FILTER = "filter",
}
